/**
 * AndVBidirectionalBar - 对称条形图组件
 * 基于 Ant Design Charts BidirectionalBar
 */
import React from 'react';
import { BidirectionalBar } from '@ant-design/plots';
import { withBaseChart, parseJsonProp } from '../base/BaseChart';
import type { AndVBidirectionalBarProps } from '../base/types';

const DEFAULT_BIDIRECTIONAL_DATA = [
  { category: '分类一', left: 40, right: 55 },
  { category: '分类二', left: 30, right: 45 },
  { category: '分类三', left: 20, right: 35 },
  { category: '分类四', left: 52, right: 48 },
  { category: '分类五', left: 38, right: 42 },
];

const BidirectionalBarWithBase = withBaseChart<AndVBidirectionalBarProps>(
  BidirectionalBar,
  {
    chartType: 'AndVBidirectionalBar',
    defaultHeight: 300,
    defaultData: DEFAULT_BIDIRECTIONAL_DATA,
  },
);

export const AndVBidirectionalBar: React.FC<AndVBidirectionalBarProps> = (props) => {
  const { xField = 'category', yField, ...baseProps } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    xField,
  };

  const parsedYField = parseJsonProp(yField);
  if (parsedYField !== undefined) {
    chartProps.yField = parsedYField;
  } else if (yField) {
    chartProps.yField = yField;
  } else {
    chartProps.yField = ['left', 'right'];
  }

  return <BidirectionalBarWithBase {...chartProps} />;
};

export type { AndVBidirectionalBarProps };
export default AndVBidirectionalBar;
